export type PublicProfileEntryContext = 'service-dashboard' | 'service-profile';

type PublicProfileBackNavigation = {
  label: string;
  target: string;
};

type PublicProfileLocationState = {
  publicProfileFrom?: unknown;
  from?: unknown;
};

const SERVICE_DASHBOARD_CONTEXT: PublicProfileEntryContext = 'service-dashboard';
const SERVICE_PROFILE_CONTEXT: PublicProfileEntryContext = 'service-profile';

const isPublicProfileEntryContext = (value: unknown): value is PublicProfileEntryContext =>
  value === SERVICE_DASHBOARD_CONTEXT || value === SERVICE_PROFILE_CONTEXT;

const coerceContextFromState = (
  state: PublicProfileLocationState | null | undefined
): PublicProfileEntryContext | null => {
  if (!state) {
    return null;
  }

  if (isPublicProfileEntryContext(state.publicProfileFrom)) {
    return state.publicProfileFrom;
  }

  if (isPublicProfileEntryContext(state.from)) {
    return state.from;
  }

  return null;
};

const coerceContextFromSearch = (
  searchParams: URLSearchParams
): PublicProfileEntryContext | null => {
  const rawFrom = (searchParams.get('from') || '').trim();
  return isPublicProfileEntryContext(rawFrom) ? rawFrom : null;
};

export const buildPublicProfileEntryState = (context: PublicProfileEntryContext) => ({
  publicProfileFrom: context,
});

export const resolvePublicProfileEntryContext = (
  state: PublicProfileLocationState | null | undefined,
  searchParams: URLSearchParams
): PublicProfileEntryContext | null =>
  coerceContextFromState(state) ?? coerceContextFromSearch(searchParams);

export const getPublicProfileBackNavigation = (
  context: PublicProfileEntryContext | null
): PublicProfileBackNavigation => {
  if (context === SERVICE_PROFILE_CONTEXT) {
    return {
      label: 'Wróć do danych serwisu',
      target: '/app/service-profile',
    };
  }

  return {
    label: 'Wróć do zleceń serwisu',
    target: '/app/service',
  };
};
